module.exports = __webpack_public_path__ + "../resources/img/guideStep3.879f4940.png";